import { z } from 'zod';

/**
 * How a lead reached us (`leads.channel`). Public form leads are `site` automatically; staff pick the channel when they
 * create a lead by hand. `unknown` marks older leads the migration could not attribute (025_lead_channels.sql).
 */
export const leadChannelValues = ['site', 'phone', 'telegram', 'max', 'referral', 'other', 'unknown'] as const;
export type LeadChannel = (typeof leadChannelValues)[number];
/** Channels staff can choose for a new lead. */
export const manualLeadChannelValues = ['site', 'phone', 'telegram', 'max', 'referral', 'other'] as const satisfies readonly LeadChannel[];
export const leadChannelLabels: Record<LeadChannel, string> = {
  site: 'Сайт (форма)',
  phone: 'Звонок',
  telegram: 'Telegram',
  max: 'MAX',
  referral: 'Повторный клиент / сарафан',
  other: 'Другое',
  unknown: 'Не указан',
};

/** «Откуда узнали» (`leads.heard_from`), optional. */
export const heardFromValues = ['search', 'site', 'tg_channel', 'friends', 'school', 'partner', 'other'] as const;
export type HeardFrom = (typeof heardFromValues)[number];
export const heardFromLabels: Record<HeardFrom, string> = {
  search: 'Яндекс/Google',
  site: 'Сайт',
  tg_channel: 'Telegram-канал',
  friends: 'Знакомые',
  school: 'Школа',
  partner: 'Партнёр',
  other: 'Другое',
};

export const manualLeadChannelSchema = z.enum(manualLeadChannelValues, { errorMap: () => ({ message: 'Выберите канал' }) });
export const leadChannelSchema = z.enum(leadChannelValues, { errorMap: () => ({ message: 'Выберите канал' }) });
export const heardFromSchema = z.enum(heardFromValues, { errorMap: () => ({ message: 'Выберите вариант из списка' }) });

/** `GET /api/admin/analytics/channels`: leads created in the period by channel. */
export type LeadChannelReportRow = {
  channel: LeadChannel;
  /** Leads created in the period. */
  leads: number;
  /** Of them now confirmed or completed. */
  accepted: number;
  /** Of them completed. */
  completed: number;
  /** Incomes in the accounting linked to these leads. */
  revenueKopecks: number;
};
export type LeadChannelReport = {
  range: { from: string; to: string };
  /** Every channel in `leadChannelValues` order, zeros included. */
  rows: LeadChannelReportRow[];
  total: Omit<LeadChannelReportRow, 'channel'>;
  /** `phone_click` goals on the site in the period (recorded with cookie consent only). */
  phoneClicks: number;
};
